@if (formControl) {
  <div class="control">
    <mat-form-field class="control__field"appearance="outline">
      <mat-label>{{ name | translate }}</mat-label>
      @if (maxLength) {
        <input
          matInput
          [ngModel]="value"
          (focusout)="propagateTouch()"
          (ngModelChange)="setNewValue($event)"
          [errorStateMatcher]="errorStateMatcher"
          [disabled]="disabled"
          [type]="inputType"
          [autocomplete]="autocompleteValue"
          [maxlength]="maxLength"
          />
      }
      @if (!maxLength) {
        <input
          matInput
          [ngModel]="value"
          (focusout)="propagateTouch()"
          (ngModelChange)="setNewValue($event)"
          [errorStateMatcher]="errorStateMatcher"
          [disabled]="disabled"
          [type]="inputType"
          [autocomplete]="autocompleteValue"
          />
      }
      @if (formControl.hasError('required') && formControl.touched) {
        <mat-error>
          {{ 'RequiredField' | translate }}
        </mat-error>
      }
      @if (formControl.invalid && formControl.touched && !formControl.hasError('required')) {
        <mat-error>
          {{ 'InvalidField' | translate }}
        </mat-error>
      }
      @if (prefix) {
        <span matPrefix>{{prefix}}&nbsp;</span>
      }
      @if (hint) {
        <mat-hint>{{ hint | translate }}</mat-hint>
      }
    </mat-form-field>
  </div>
}
